export var PromiseStatus;
(function (PromiseStatus) {
    PromiseStatus[PromiseStatus["pending"] = 0] = "pending";
    PromiseStatus[PromiseStatus["fulfilled"] = 1] = "fulfilled";
    PromiseStatus[PromiseStatus["rejected"] = 2] = "rejected";
})(PromiseStatus || (PromiseStatus = {}));
export function makeQueryablePromise(promise) {
    if ("status" in promise)
        return promise;
    let status = PromiseStatus.pending;
    const result = promise.then(value => {
        status = PromiseStatus.fulfilled;
        return value;
    }, error => {
        status = PromiseStatus.rejected;
        throw error;
    });
    result.status = () => status;
    return result;
}

// @zapier/stripe@1.0.0 (4143d282b)
